import { z } from "zod";

export const APP_ROLES = [
  "geschaeftsleitung",
  "bereichsleiter",
  "stellvertreter",
  "projektleiter",
  "admin",
] as const;

export type AppRole = (typeof APP_ROLES)[number];
export const appRoleSchema = z.enum(APP_ROLES);

export const QUADRANTS = ["star", "cash_cow", "question_mark", "dog"] as const;
export type Quadrant = (typeof QUADRANTS)[number];
export const quadrantSchema = z.enum(QUADRANTS);
